import React from "react";
import { TactsuitInteractionScrollInfo } from "@/v2-components/pages/tactsuit/tactsuit-air/components/tactsuit-interaction-scroll-info";
import Container from "@/components/commons/Container";
import { useTactsuitAirImgLoaded } from "@/v2-components/pages/tactsuit/tactsuit-air/hooks/use-tactsuit-air-img-loaded";
import { TactsuitInteractionScrollCanvas } from "@/components/tactsuit/tactsuit-interaction-scroll-canvas";

export const TactsuitAirInteractionScrollContainer = () => {
  const { images, isLoaded } = useTactsuitAirImgLoaded();

  return (
    <Container className="labtop:mx-4 mx-0 flex w-full flex-1 flex-col items-center bg-coolgray-10">
      <div className="align-center flex w-full flex-col gap-6 laptop:flex-row">
        <TactsuitInteractionScrollCanvas images={images} imagesRange={90} />
        <TactsuitInteractionScrollInfo />
      </div>
    </Container>
  );
};
